import { render, staticRenderFns } from "./inventory.vue?vue&type=template&id=ecbbc906&scoped=true&"
import script from "./inventory.vue?vue&type=script&lang=ts&"
export * from "./inventory.vue?vue&type=script&lang=ts&"
import style0 from "./inventory.vue?vue&type=style&index=0&id=ecbbc906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbbc906",
  null
  
)

export default component.exports